


// import { createSlice } from "@reduxjs/toolkit";

// // Helper Functions for Local Storage
// const setAuthData = (token, user) => {
//   console.log("Storing user_id:", user.id); // ✅ Debugging line
//   localStorage.setItem("authToken", token);
//   localStorage.setItem("user", JSON.stringify(user));
//   localStorage.setItem("user_id", user.id);
// };

// const clearAuthData = () => {
//   localStorage.removeItem("authToken");
//   localStorage.removeItem("user");
//   localStorage.removeItem("user_id");
// };

// // Initial State
// const initialState = {
//   isAuthenticated: !!localStorage.getItem("authToken"),
//   user: JSON.parse(localStorage.getItem("user")) || null,
//   user_id: localStorage.getItem("user_id") || null,
// };

// const authSlice = createSlice({
//   name: "auth",
//   initialState,
//   reducers: {
//     signup: (state, action) => {
//       const { first_name, last_name } = action.payload;
//       if (state.user) {
//         state.user.first_name = first_name;
//         state.user.last_name = last_name;
//       } else {
//         state.user = { first_name, last_name };
//       }
//     },

//     login: (state, action) => {
//       const { user, token } = action.payload;
//       if (!user || !token) return; // Ensure valid data

//       const userId = user.id || null;
//       state.isAuthenticated = true;
//       state.user = user; // Store the full user object
//       state.user_id = userId;

//       setAuthData(token, user);
//     },

//     logout: (state) => {
//       state.isAuthenticated = false;
//       state.user = null;
//       state.user_id = null;
//       clearAuthData();
//     },
//   },
// });

// export const { signup, login, logout } = authSlice.actions;
// export default authSlice.reducer;


import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: !!localStorage.getItem("authToken"),
  user: JSON.parse(localStorage.getItem("user")) || null,
  authToken: localStorage.getItem("authToken") || null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      const { user, token } = action.payload;
      state.isAuthenticated = true;
      state.user = user;
      state.authToken = token;

      localStorage.setItem("authToken", token);
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("user_id", user.id); // Explicitly store user_id
    },

    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.authToken = null;

      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
      localStorage.removeItem("user_id");
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
